<template>
  <div class="radio" :class="setClassModifiers('radio--')">
    <input
      type="radio"
      :name="name"
      :id="'radio-' + val"
      :value="val"
      :disabled="disabled"
      v-model="inputValue"
      class="radio__input"
    >
    <label :for="'radio-' + val" class="radio__label">
      <i class="radio__label-icon"></i>

      <div class="radio__label-text">

        <div class="radio__label-title">
          <!-- @slot Label title -->
          <slot></slot>
        </div>

        <div class="radio__label-description" v-if="$slots.description">
          <!-- @slot Grey description text -->
          <slot name="description"></slot>
        </div>

        <div class="radio__label-info" v-if="$slots.info">
          <!-- @slot A text below the description -->
          <slot name="info"></slot>
        </div>
      </div>
    </label>
  </div>
</template>

<script>
import emitInputValue from '@/mixins/emitInputValue'
import setClassModifiers from '@/mixins/setClassModifiers'

export default {
  name: 'v-radio',
  mixins: [emitInputValue, setClassModifiers],
  props: {
    name: {
      type: String,
      default: null
    },
    /**
      * Initial values of radio buttons
      */
    val: {
      type: [String, Number],
      default: null
    },
    /**
      * @values tertiary, white, grey
      */
    color: {
      type: String,
      default: 'tertiary'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
  .radio {
    padding-top: .3rem;
    padding-bottom: .2rem;

    &__input {
      display: none;
    }

    &__label {
      cursor: pointer;
      font-family: inherit;
      font-size: inherit;
      display: flex;
      align-items: flex-start;
      position: relative;
      padding-top: 1rem;
      padding-bottom: 1rem;

      &-icon {
        position: relative;
        min-width: 1.6rem;
        height: 1.6rem;
        width: 1.6rem;
        border: 1px $color-secondary solid;
        border-radius: 50%;
        font-size: 1.2rem;
        padding: 0 .15rem;
        transition: all .2s;
        display: block;
        margin-right: .7rem;
        margin-top: .3rem;
      }
    }

    &--filled {
      .radio__label {
        &-icon {
          border: none;
          background-color: $color-grey-light;
          min-width: 1.2rem;
          height: 1.2rem;
          width: 1.2rem;
        }
      }
    }

    &--filled &__input:checked + &__label &__label-icon {
      background-color: $color-secondary;
    }

    &__input:checked + &__label &__label-icon::before {
      content: '';
      background-color: $color-secondary;
      position: absolute;
      width: 1rem;
      height: 1rem;
      border-radius: 50%;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;
    }

    //&--filled {
    //  .radio__label-icon::before {
    //    content: '';
    //    width: 1rem;
    //    height: 1rem;
    //    border-radius: 50%;
    //    left: 50%;
    //    top: 50%;
    //
    //    transform: translate(-50%, -50%);
    //    z-index: 1;
    //  }
    //}

    &--white {
      .radio__input:checked + .radio__label .radio__label-icon::before {
        background-color: $color-white;
      }

      .radio__label-icon {
        border-color: $color-white;
      }
    }

    &--grey {
      .radio__input:checked + .radio__label .radio__label-icon::before {
        background-color: $color-grey-lighten;
      }

      .radio__label-icon {
        border-color: $color-grey-lighten;
      }
    }

    &__input:disabled,
    &__input:disabled + &__label {
      opacity: .45;
      cursor: default;
    }

    &__label-text {
      display: flex;
      flex-direction: column;
      width: 100%;

      & > *:not(:last-child) {
        margin-bottom: .5rem;
      }
    }

    &__label-description {
      color: $color-grey-dark;
      font-size: 1.5rem;
    }

    &__label-info {
      font-size: 1.5rem;
    }
  }
</style>
